import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowCircleRight } from '../shared/icons';
import { FOOTER_LOGO } from '../shared/assets';
import './footer.css';

export default () => {
    const footerLinks = [
        { path: "/", label: "Home" },
        { path: '/about', label: 'About Us' },
        { path: '/team', label: 'Our Team' },
        { path: '/news', label: 'Local News' },
        { path: 'https://www.facebook.com/NRNAAustralia', label: 'NRNA Australia Facebook' },

    ]
    return (
        <div className="footer-container">
            <footer>
                <img src={FOOTER_LOGO} className="footer-logo"/>
                <ul className="footer-links">
                    {footerLinks.map(link => <li key={link.path}>
                        {
                            isAbsoluteLink(link.path) ? 
                            (<a href={link.path} target="_blank">{link.label}</a>) :
                            (<Link to={link.path}>{link.label}</Link>)
                        }
                    </li>)}
                </ul>
                <span>Copyright &copy; {new Date().getFullYear()} Non-Resident Nepali Association Australia</span>
            </footer>
        </div>
    )
}

const isAbsoluteLink = (link) => link.startsWith('http');
